// extracted by mini-css-extract-plugin
export default {"recentSearchContainer":"RecentSearch__recentSearchContainer___Wi15o","headingWrapper":"RecentSearch__headingWrapper___f_b0L"};